import { render, staticRenderFns } from "./SecondaryCommission.vue?vue&type=template&id=1989bbcc&scoped=true"
import script from "./SecondaryCommission.vue?vue&type=script&lang=js"
export * from "./SecondaryCommission.vue?vue&type=script&lang=js"
import style0 from "./SecondaryCommission.vue?vue&type=style&index=0&id=1989bbcc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1989bbcc",
  null
  
)

export default component.exports